import cookies from '@buzzfeed/bf-utils/lib/cookies';

/**
 * Get or generate XSRF token cookie.
 * Ensures _xsrf cookie exists before returning its value.
 * @returns {string} XSRF token value
 */
export const getXsrfToken = () => {
  let xsrf = cookies.get('_xsrf');
  if (!xsrf) {
    xsrf = Math.random().toString(36).substring(2);
    cookies.set({
      name: '_xsrf',
      value: xsrf,
    });
  }
  return xsrf;
};
